export default __webpack_public_path__ + "static/media/CONSTRUCTION_INDUSTRIAL.7afa102e.png";